import { render, staticRenderFns } from "./addBindCoach.vue?vue&type=template&id=34e1d8e9&"
import script from "./addBindCoach.vue?vue&type=script&lang=js&"
export * from "./addBindCoach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e1d8e9')) {
      api.createRecord('34e1d8e9', component.options)
    } else {
      api.reload('34e1d8e9', component.options)
    }
    module.hot.accept("./addBindCoach.vue?vue&type=template&id=34e1d8e9&", function () {
      api.rerender('34e1d8e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/teammanagemant/teamList/component/addBindCoach.vue"
export default component.exports